import React, { useEffect, useState } from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Loyalty } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import "./BadgeNodeGroup.css";

const BadgeNodeGroup = (props) => {

    const navigate = useNavigate();
    const state = useLocation();
    const [active, setActive] = useState();

    useEffect(() => {
        const activeItemId = state && state.state && state.state.activeItemId;
        if(activeItemId) {
            setActive(activeItemId);
        }
    },[state]);

    return (
        <List component="div" disablePadding>
            <ListItemButton id="2001"
                className={(active === 2001) ? "kmc-console-badge-litem-active" : ""}
                onClick={() => {
                    navigate('/manage/badges', { state: { isBadgeNodeExpand: true } });
                    setActive(2001);
                }
                }>
                <ListItemIcon>
                    <Loyalty fontSize='medium' />
                </ListItemIcon>
                <ListItemText primary={'Manage Badges'} />
            </ListItemButton>
        </List>
    )
}

export default BadgeNodeGroup;